const SettleProductIcon = (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M2.975,2.5c0-1.381,1.119-2.5,2.5-2.5s2.5,1.119,2.5,2.5-1.119,2.5-2.5,2.5-2.5-1.119-2.5-2.5ZM22.604,15.789l-3.604,2.279v5.932h-2v-7.033l1.565-.99-1.217-6.398-1.348,2.273v5.147H8.001v-5.103l-1.379-2.325-1.236,6.39,1.589,1.005v7.033h-2v-5.932l-3.604-2.279C.322,15.126-.214,13.862,.037,12.646l.878-4.253c.287-1.387,1.522-2.394,2.938-2.394h1.267c1.054,0,2.042,.563,2.58,1.471l.907,1.529h6.76l.907-1.529c.538-.907,1.527-1.471,2.581-1.471h1.267c1.416,0,2.652,1.007,2.938,2.394l.878,4.253c.251,1.216-.285,2.479-1.334,3.143Zm-4.103-10.789c1.381,0,2.5-1.119,2.5-2.5s-1.119-2.5-2.5-2.5-2.5,1.119-2.5,2.5,1.119,2.5,2.5,2.5ZM0,24H2.054l1.04-4.756-1.8-1.138L0,24Zm20.881-4.756l1.04,4.756h2.053l-1.293-5.895-1.8,1.138Z" />
  </svg>
);

export default SettleProductIcon;
